import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";

import { Fieldset } from "rbx";
import { EditFormButtonGroup } from "../inputs";
import Section from "../Section";

import TariffForm from "./TariffForm";
import { getUTCFormattedDate, ourToast as toast } from "../../utils";

import {
  UPDATE_TARIFF_MUTATION,
  DELETE_TARIFF_MUTATION
} from "../../graphql/Tariffs/Tariffs.graphql";

class EditTariffForm extends Component {
  state = {
    TariffCode: "",
    Description: "",
    BeginDate: "",
    EndDate: "",
    MinLoad: "",
    MaxLoad: "",
    MinCharge: "",
    TariffTypeRecIdRef: "",
    ...this.props.tariff
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const { setModalOpen } = this.props;
    const {
      TariffCode,
      Description,
      BeginDate,
      EndDate,
      MinLoad,
      MaxLoad,
      MinCharge,
      TariffTypeRecIdRef
    } = this.state;
    return (
      <Section title="Edit Tariff">
        <Mutation
          mutation={UPDATE_TARIFF_MUTATION}
          refetchQueries={["ALL_TARIFFS_QUERY"]}
          variables={{
            data: {
              TariffCode,
              Description,
              BeginDate: getUTCFormattedDate(BeginDate),
              EndDate: getUTCFormattedDate(EndDate),
              MinLoad: parseInt(MinLoad),
              MaxLoad: parseInt(MaxLoad),
              MinCharge: parseInt(MinCharge),
              TariffTypeRecIdRef: parseInt(TariffTypeRecIdRef)
            },
            where: { RecId: this.props.tariff.RecId }
          }}
        >
          {(updateTariff, { loading, error }) => (
            <form
              id="edit-tariff"
              method="POST"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await updateTariff();
                  setModalOpen(false);
                  toast.success("Tariff updated successfully.");
                } catch (err) {
                  toast.error("Error updating Tariff.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <TariffForm
                  inputs={{
                    TariffCode,
                    Description,
                    BeginDate,
                    EndDate,
                    MinLoad,
                    MaxLoad,
                    MinCharge,
                    TariffTypeRecIdRef
                  }}
                  onChange={this.onChange}
                />
                <EditFormButtonGroup
                  deleteMutation={DELETE_TARIFF_MUTATION}
                  form="edit-tariff"
                  refetchQueries={["ALL_TARIFFS_QUERY"]}
                  variables={{ where: { RecId: this.props.tariff.RecId } }}
                  onComplete={setModalOpen}
                />
              </Fieldset>
            </form>
          )}
        </Mutation>
      </Section>
    );
  }
}

EditTariffForm.propTypes = {
  setModalOpen: PropTypes.func,
  tariff: PropTypes.object
};

export default EditTariffForm;
